import { z } from "zod";
/**
 * Persisté dans `ReportFile.data` : `bounced` vient du webhook Postmark, les autres
 * statuts du résultat d’envoi. Absent ou null reste un état historique valide.
 */
export const emailStatusSchema = z.enum(["sent", "skipped", "failed", "bounced", "uncertain"]);
/**
 * `sent` reste silencieux (cas nominal, aucune action requise). Tout le reste — `skipped`
 * (case décochée ou pas d'email à la création), `bounced`/`failed` (envoi tenté et
 * confirmé en échec), `uncertain` (issue de l'envoi inconnue), ou absent/`null` — reste
 * actionnable : la popup de renvoi doit rester joignable tant que l'attestation n'a pas
 * été envoyée avec succès (§4 du PRD : ajouter l'email puis rouvrir l'attestation).
 * `not-sent`/`failed` ne distinguent que l'affichage (gris foncé vs rouge d'erreur), pas
 * la clic-abilité. (#1270)
 */
export function getEmailStatusBadgeState(emailStatus) {
    if (emailStatus === "sent") {
        return null;
    }
    if (emailStatus === "uncertain") {
        return "uncertain";
    }
    return emailStatus === "failed" || emailStatus === "bounced" ? "failed" : "not-sent";
}
//# sourceMappingURL=emailStatus.js.map